import VueMatomoModule from 'vue-matomo';
import type { Plugin } from 'vue';

// vue-matomo ships a webpack UMD bundle (`module.exports = { __esModule, default: install }`).
// Vite 8 (Rolldown) imports it in Node interop mode, so the default import is that whole
// object rather than `install`, and `app.use()` silently ignores it in production — the
// tracker never loads. Unwrap the nested default when present.
const VueMatomo: Plugin = (VueMatomoModule as { default?: Plugin }).default ?? VueMatomoModule;

// Only the production site reports to Matomo: local development and other hosts
// would otherwise pollute the live statistics and goals.
const TRACKED_HOSTS = new Set([ 'wiresock.net', 'www.wiresock.net' ]);

export default defineNuxtPlugin((nuxtApp) => {
  // The queue always exists: components push to it directly. Without the tracker
  // loaded nothing consumes it, so on other hosts the pushes are simply dropped.
  window._paq = window._paq || [];

  if (!TRACKED_HOSTS.has(window.location.hostname)) {
    return;
  }

  nuxtApp.vueApp.use(VueMatomo, {
    host: 'https://stat.wiresock.net',
    siteId: 1,
    router: nuxtApp.$router,
  });
  window._paq.push(['requireCookieConsent']);
});
